// refers to a translatable key to be displayed on the list view
export const FALLBACK_CATEGORY_NAME = 'Other Products' as const
export const MISSING_ITEMS_CATEGORY_NAME = 'Missing Products' as const
